import React, { Suspense } from "react";

import { Spinner, Button } from "react-bootstrap";
import { registerLocale } from "react-datepicker";
import pl from "date-fns/locale/pl"; // the locale you want

import FechGetClientsBySearch from "../APP_RESERVATION_FECH_DATA/FechGetClientsBySearch";

import PageCounterNew from "../components/PageCounterNew";
import BeltReservationApp from "../APP_RESERVATION_COMPONENTS/BeltReservationApp";

import queryString from "query-string";
import moment from "moment";
import ParseLinkToArray from "../utils/ParseLinkToArray";

const AddClientPopupForm = React.lazy(() =>
  import("../APP_RESERVATION_FORM_POPUP/AddClientPopupForm")
);
const TabAllClients = React.lazy(() =>
  import("../APP_RESERVATION_COMPONENTS/TabAllClients")
);
const SearchClients = React.lazy(() =>
  import("../APP_RESERVATION_FORMS/SearchClients")
);

let plLocate = require("moment/locale/pl");
moment.locale("pl", plLocate);

//KLASA WYSWIETLA SZCZEGOLY KONKRETNYCH ZAJEC SZKOLKI
class PageClients extends React.Component {
  TRAINER_SELECT_DESC = "Wybierz trenera";
  DATE_SELECT_DESC = "Wybierz datę";
  CLASS_SELECT_DESC = "Wybierz szkółke";

  urlDeafulValues = [
    this.TRAINER_SELECT_DESC,
    this.CLASS_SELECT_DESC,
    this.DATE_SELECT_DESC,
  ];

  urlValue = "";

  postData = {
    clientId: "",
    sortBy: "",
    status: "",
    searchDirection: "",
    page: "0",
  };

  constructor(props) {
    super(props);

    this.state = {
      title: "BACKUP RezerwujKort.pl - Rezerwację",
      datePickerIsOpen: false,
      previousDay: "",
      refreshReservation: "",
      AddClientPopupForm: "",
      restClientsData: {
        successful: false,
        status: "",
        message: "",
        data: [],
      },
    };
    this.handlerRefreshReservation = this.handlerRefreshReservation.bind(this);
  }

  async componentDidMount() {

    const club = this.props.match?.params?.club ?? "";
    const truncatedClub = club.length > 20 ? club.slice(0, 20) : club;

    const title = "Klienci BACKUP " + truncatedClub + " App - RezerwujKort.pl";
    document.title = title;

    if (window._paq) {
      window._paq.push(['setDocumentTitle', title]);
    }

    registerLocale("pl", pl); // register it with the name you want
    const {
      location: { search },
    } = this.props;
    this.state.search = search;
    this.urlValue = queryString.parse(this.state.search);

    this.postData = await ParseLinkToArray(
      this.urlValue,
      this.postData,
      this.urlDeafulValues
    );

    this.setState({
      restClientsData: await FechGetClientsBySearch(
        this.props.match.params.club,
        search
      ),
    });

    var cc = this.state.restClientsData;
  }

  async addClientForm() {
    this.setState({
      addClientPopupForm: (
        <div>
          <Suspense
            fallback={
              <div>
                <Spinner
                  style={{ borderStyle: "dotted", marginLeft: "50%" }}
                  animation="border"
                />
              </div>
            }
          >
            <AddClientPopupForm
              dateReservation={""}
              club={this.props.match.params.club}
              refresh={this.handlerRefreshReservation}
            />
          </Suspense>
        </div>
      ),
    });
  }

  async handlerRefreshReservation() {
    //this.componentDidMount();
    const {
      location: { search },
    } = this.props;
    this.state.search = search;
    this.urlValue = queryString.parse(this.state.search);
    this.postData = await ParseLinkToArray(
      this.urlValue,
      this.postData,
      this.urlDeafulValues
    );

    this.setState({
      restClientsData: await FechGetClientsBySearch(
        this.props.match.params.club,
        search
      ),
    });
  }

  render() {
    var loader = "";
    if (!this.state.restClientsData.successful) {
      loader = (
        <div id="loader_div">
          <Spinner animation="border" />
        </div>
      );
      totalRecords = this.state.restClientsData.data;
    }

    var totalRecords = "";
    var tabAllClients = "";
    var pageCounter = "";
    var searchPanel;

    if (this.state.restClientsData.successful) {
      totalRecords = this.state.restClientsData.data.totalRecordsCount;

      tabAllClients = (
        <div>
          <Suspense
            fallback={
              <div>
                <Spinner
                  style={{ borderStyle: "dotted", marginLeft: "50%" }}
                  animation="border"
                />
              </div>
            }
          >
            <TabAllClients
              club={this.props.match.params.club}
              restLessonsData={this.state.restClientsData.data.clientResources}
              refresh={this.handlerRefreshReservation}
            />
          </Suspense>
        </div>
      );

      const urlValues = new Map();
      urlValues.set("clientId", this.postData.clientId);
      urlValues.set("sortBy", this.postData.sortBy);
      urlValues.set("status", this.postData.status);
      urlValues.set("searchDirection", this.postData.searchDirection);
      urlValues.set("page", "replace");

      pageCounter = (
        <PageCounterNew
          elementCount={totalRecords}
          urlValues={urlValues}
          urlDeafulValues={this.urlDeafulValues}
          elementOnPage={this.state.restClientsData.data.recordsOnPage}
          currentPage={parseInt(this.postData.page) + 1}
          searchName={"search"}
          linkTo={
            "reservation_app/" + this.props.match.params.club + "/klienci"
          }
        />
      );

      searchPanel = (
        <div>
          <Suspense
            fallback={
              <div>
                <Spinner
                  style={{ borderStyle: "dotted", marginLeft: "50%" }}
                  animation="border"
                />
              </div>
            }
          >
            <SearchClients
              urlValue={this.postData}
              club={this.props.match.params.club}
            />
          </Suspense>
        </div>
      );
    }

    return (
      <div>
        <div id="content">
          <BeltReservationApp club={this.props.match.params.club} />

          {searchPanel}

          <Button
            href="#"
            variant="success"
            size="lg"
            style={{ "margin-left": "20px" }}
            onClick={() => this.addClientForm()}
          >
            Dodaj klienta
          </Button>

          <br />
          <br />
          <b>Lista wszystkich klientów: ({totalRecords}):</b>
          <br />
          <br />

          {this.state.addClientPopupForm}
          {loader}

          {tabAllClients}

          {pageCounter}
        </div>
      </div>
    );
  }
}
export default PageClients;
